export default {
    getTemplete(id) {
        var found = templetes.find( (templete) => {
            return templete.db === id
        })
        return found
    },
    getTempletes() {
        return templetes
    },
    getDefaultTemplete() {
        let defaultTemeplete =     {
            url : 'http://www.hhiun.or.kr/Notice',
            db : '',
            name : '기본',
            data: [
                {
                    category: "조식",
                    data: []
                },
                {
                    category: "중식",
                    data: []
                },
                {
                    category: "석식",
                    data: []
                },
                {
                    category: "야식",
                    data: []
                },
                {
                    category: "이동",
                    data: []
                }
            ]
        }
        return defaultTemeplete
    }
}


const templetes =
[
    {
        url : 'https://www.hanyang.ac.kr/web/www/re2',
        db : 'hanyang',
        name : '한양대',
        data :     [
            {
                category: '조식',
                data: [
                        {title:'조식',items:[]},
                        ]
            },
            {
                category: '중식',
                data: [
                        {title: '중식[Dam-A]', items:[]},
                        {title: '중식[Pangeos]', items:[]},
                        {title: '중식[마루]', items:[]},
                        {title: '중식[채움]', items:[]}
                        ]
            },
            {
                category: '석식',
                data: [                                
                        {title:'석식[Dam-A]',items:[]},
                        {title:'석식[Pangeos]',items:[]},
                        {title:'석식[채움]',items:[]}
                        ]
            },
            {
                category: '야식',
                data: [
                        {title:'야식',items:[]},
                        ]
            }
        ]
    },
    {
        url : 'https://www.hanyang.ac.kr/web/www/re11#none',
        db : 'hanyang_erica',
        name : '한양대-에리카',
        data :     [
            {
                category: '조식',
                data: [
                        {title:'조식',items:[]},
                        ]
            },
            {
                category: '중식',
                data: [
                        {title: '중식1', items:[]},
                        {title: '중식2', items:[]}
                        ]
            },
            {
                category: '석식',
                data: [                                
                        {title:'석식',items:[]}
                        ]
            },
            {
                category: '야식',
                data: [
                        {title:'야식',items:[]},
                        ]
            }
        ]
    },    
    {
        url : 'http://skkumed.org/menu',
        db : 'samsung_hospital',
        name : '삼성병원',
        data: [
            {
                category: '조식',
                data: [
                        {title:'아침A',items:[]},
                        {title:'아침B',items:[]}
                        ]
            },
            {
                category: '중식',
                data: [
                        {title: '중식A', items:[]},
                        {title: '별관-중식A', items:[]},
                        {title: '별관-중식B', items:[]}
                        ]
            },
            {
                category: '석식',
                data: [
                        {title:'저녁A',items:[]},
                        {title:'저녁B',items:[]}
                        ]
            },
            {
                category: '야식',
                data: [                                
                    {title:'야식A',items:[]},
                    {title:'야식B',items:[]}
                        ]
            }
        ]
    },
    {
        url : 'http://www.hhiun.or.kr/Notice',
        db : 'hdhardwork',
        name : '현대중공업(현장)',
        data: [
            {
                category: "조식",
                data: [{title:'한식',items:[]},{title:'라면,죽',items:[]},{title:'간편식',items:[]}]
            },
            {
                category: "중식",
                data: [{title:'한식',items:[]},{title:'일품',items:[]}]
            },
            {
                category: "석식",
                data: [{title:'한식',items:[]}]
            },
            {
                category: "야식",
                data: [{title:'야식',items:['-']}]
            }
        ]
    },
    {
        url : 'http://www.hhiun.or.kr/Notice',
        db : 'hdhardwork_rest',
        name : '현대중공업(숙소)',
        data: [
            {
                category: "조식",
                data: [{title:'뷔페',items:['-']}]
            },
            {
                category: "중식",
                data: [{title:'한식',items:[]}]
            },
            {
                category: "석식",
                data: [{title:'한식',items:[]}]
            },
            {
                category: "야식",
                data: [{title:'야식',items:['-']}]
            }
        ]
    },
    {
        url : 'http://m.welliv.co.kr/mobile/mealmenu_list.jsp',
        db : 'dwjosun',
        name : '대우조선해양',
        data: [
            {
                category: "조식",
                data: [{title:'한식(쌀밥)',items:[]},
                        {title:'간편식',items:[]},
                        {title:'해장국',items:[]}
                ]
            },
            {
                category: "중식",
                data: [{title:'한식(쌀밥)',items:[]},
                        {title:'한식(잡곡밥)',items:[]},
                        {title:'분식',items:[]},
                        {title:'건강식',items:[]},
                        {title:'선택코너',items:[]}
                ]
            },
            {
                category: "석식",
                data: [{title:'한식(쌀밥)',items:[]},
                        {title:'일품식',items:[]}
                ]
            },
            {
                category: "야식",
                data: [{title:'야식',items:['-']}]
            }
        ]
    },    
    {
        url : 'http://www.gmno.or.kr/bbs/board.php?bo_table=sikdan',
        db : 'gmkorea',
        name : '지엠코리아',
        data : [
            {
                category: "조식",
                data: [{title:'A',items:[]}, {title:'B',items:[]}]
            },
            {
                category: "전,후반조 중식",
                data: [{title:'A',items:[]}, {title:'B',items:[]}]
            },
            {
                category: "석식",
                data: [{title:'석식',items:[]}]
            },
            {
                category: "후반조죽류",
                data: [{title:'후반조죽류',items:['-']}]
            },
            {
                category: "야식",
                data: [{title:'야식',items:['-']}]
            }
        ]
    },
    {
        url : '',
        db : 'seoulasan',
        name : '서울아산병원',
        data: [
            {
                category: '조식',
                data: [
                        {title:'A',items:[]},
                        {title:'B',items:[]}
                        ]
            },
            {
                category: '중식',
                data: [                                
                        {title: '동관', items:[]},
                        {title: '서신관', items:[]},
                        {title: '수술장', items:[]},
                        {title: '도시락', items:[]},
                        ]
            },
            {
                category: '석식',
                data: [                                
                        {title:'A',items:[]},
                        {title:'B',items:[]}
                        ]
            },
            {
                category: '야식',
                data: [                                
                    {title:'A',items:[]}
                        ]
            },
            {
                category: '이동식',
                data: [                                
                    {title:'A',items:[]},
                    {title:'B',items:[]},
                    {title:'C',items:[]}
                        ]
            }
        ]
    },
    {
        url : 'http://www.nunting.kr',
        db : 'test',
        name : '샘플',
        data: [
            {
                category: "조식",
                data: []
            },
            {
                category: "중식",
                data: []
            },
            {
                category: "석식",
                data: []
            },
            {
                category: "야식",
                data: []
            },
            {
                category: "이동",
                data: []
            }
        ]
    }
]


